<div class="fs-2 with-close" mat-dialog-title>
    Dupliquer votre secteur
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <form (ngSubmit)="onYesClick()" [formGroup]="favoriteForm">
        <mat-form-field class="mt-3 pb-0">
            <mat-label>Nom</mat-label>
            <input formControlName="title" matInput class="text">
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Enregistrer</ng-container>
    </button>
</div>
